import React, { useState, useEffect } from 'react';
import Icon from '../../../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import { useUnreadThreads } from '../../../Data/Messages';

const Inbox = () => {
    const {unread} = useUnreadThreads();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        setUnreadCount(unread?.length ?? 0);
    }, [unread]);

    return <Link to="/messages">
        <Icon icon="Message"
            theme={unreadCount > 0 ? "solid" : "light"}
            className={unreadCount > 0 ? "fill-brand" : null}
            size="2x"
            badge={unreadCount}
        />
    </Link>;
};

export default Inbox;
